import React from 'react';
import { Car } from '../types/car';
import { formatARS, formatKm } from '../utils/format';
interface CarSummaryProps {
  car: Car;
}
export function CarSummary({
  car
}: CarSummaryProps) {
  return <div className="flex items-center gap-4 rounded-xl border border-line bg-ink p-3" data-id="element-44" data-mp="3l0sfu7a4n5r4">
      <img src={car.image} alt="" className="h-16 w-24 shrink-0 rounded-lg object-cover" data-id="element-45" data-mp="3g0wc895cdgc3" />
      <div className="min-w-0" data-id="element-46" data-mp="2sblivcqbmo7z">
        <p className="truncate font-display text-lg font-semibold text-white" data-id="element-47" data-mp="2scwlh9815pxi">
          {car.brand} {car.model} <span className="font-medium text-muted" data-id="element-48" data-mp="2ne25ef1g6fh3">{car.version}</span>
        </p>
        <p className="text-xs text-muted" data-id="element-49" data-mp="32ab1x8tyeept">
          {car.year} · {formatKm(car.km)} · Contado <span className="font-semibold text-neon" data-id="element-50" data-mp="2xaez3cwzstbu">{formatARS(car.cashPrice)}</span>
        </p>
      </div>
    </div>;
}